import React from 'react';
import { Table } from 'src/components/common/Table';
import { useGetFuturePrices } from '../api';
import { FuturePrice } from '../model';
import { format } from 'date-fns';
import { Link } from '@mui/material';
import { routesMap } from 'src/routes';

interface Props {}

export const FuturePricesList: React.FunctionComponent<Props> = ({}) => {
  const pricesReuest = useGetFuturePrices({
    variables: {},
  });
  return (
    <div>
      <Table
        loading={pricesReuest.isLoading}
        data={pricesReuest.data?.data || []}
        totalCount={pricesReuest.data?.totalCount || 0}
        title="Изменения цен"
        headers={[
          {
            title: 'id',
            component: 'th',
            scope: 'row',
            align: 'right',
            extract: (item: FuturePrice) => <Link href={routesMap.futurePrice.getRoute(item.vendorId)}>{item.vendorId}</Link>,
          },
          {
            title: 'Дата',
            align: 'right',
            extract: (item: FuturePrice) =>
              format(new Date(item?.date), 'yyyy-MM-dd HH:mm:ss'),
          },
          {
            title: 'Активна',
            align: 'right',
            extract: (item: FuturePrice) => (item.activity ? 'Да' : 'Нет'),
          },
          {
            title: 'Количество товаров',
            align: 'right',
            extract: (item: FuturePrice) => item.linesCount,
          },
          {
            title: 'importId',
            align: 'right',
            extract: (item: FuturePrice) => item.importId,
          },
        ]}
      />
    </div>
  );
};
